import { render } from "./Tgmenber.vue?vue&type=template&id=296764b9&scoped=true"
import script from "./Tgmenber.vue?vue&type=script&lang=js"
export * from "./Tgmenber.vue?vue&type=script&lang=js"

import "./Tgmenber.vue?vue&type=style&index=0&id=296764b9&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296764b9"]])

export default __exports__